import React, { Component } from 'react'
import { Link } from 'gatsby'
import get from 'lodash/get'
import { buildURL } from '../../utils/url'
import EventTracker from './../../helpers/EventTracker'
import moment from 'moment'

export default class BlogStoryBlockWidget extends Component {
    render() {
        const { className } = this.props
        const { title, summary, heroImage, headerImage, image, backgroundImage, updatedAt } = this.props.data

        // Handle different image fields based on content type
        const contentImage = heroImage || headerImage || image || backgroundImage || null
        const backgroundImageUrl = get(contentImage, 'file.url', null)
        const backgroundImageTitle = get(contentImage, 'title', null)
        const internalUrl = buildURL(this.props.data)
        return (
            <Link
                to={internalUrl}
                className={`block story-block ${className ? className : ''}`}
                onClick={() => EventTracker.customEvent(EventTracker.EVENT_CATEGORIES.STORY_BLOCK, EventTracker.EVENT_TYPES.CLICK, 'CARD')}
                style={{ textDecoration: 'none' }}
            >
                <div className="block-heading">
                    <img src={backgroundImageUrl || '/placeholder.svg'} alt={backgroundImageTitle} />
                </div>
                <div className="block-info">
                    <div className="block-body">
                        <span className="date">Starship Hospital - {moment(updatedAt).format('D MMMM YYYY')}</span>
                        <h4>{title}</h4>
                        <p>{get(summary, 'summary')}</p>
                    </div>
                    <div className="block-links">
                        <span className="buttonLink read-more-link">
                            <span className="read-more-link-text">{this.props.data.goToPage ? this.props.data.goToPage : 'Read More'}</span>
                            <i className="fa fa-arrow-right icon" />
                        </span>
                    </div>
                </div>
            </Link>
        )
    }

}
